export enum FormEventEnum {
  FORM_START = 'form_start',
  FORM_COMPLETE = 'form_complete',
  FORM_ERROR = 'form_error',
  FORM_ABANDONED = 'form_abandoned'
}
